import React from 'react';
import { func, bool } from 'prop-types';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button, Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';

const OpenDrawerButton = ({ onClick = noop, loading = false }) => (
    <Button type="button" onClick={onClick} loading={loading}>
        <I18n k={'gig_page_perseus.packages.continue'}/>
        <Icon className="rf" color={Button.COLORS.WHITE}>{l_arrow_right}</Icon>
    </Button>
);

OpenDrawerButton.propTypes = {
    onClick: func,
    loading: bool
};

export default OpenDrawerButton;
